import {LocalCustomerModel} from './LocalCustomerModel';
import {RegionModel} from './RegionModel';

export class LocalCustomerSettingsModel {
  id: number;
  localCustomer: LocalCustomerModel;
  region: RegionModel;


  constructor(id?: number, localCustomer?: LocalCustomerModel, region?: RegionModel) {
    this.id = id;
    this.localCustomer = localCustomer;
    this.region = region;
  }

  public static clone(obj: LocalCustomerSettingsModel): LocalCustomerSettingsModel {
    const result: LocalCustomerSettingsModel = new LocalCustomerSettingsModel();

    result.localCustomer = obj.localCustomer;
    result.region = obj.region;

    return result;
  }
}
